export { CollectionInfoHeaderComponent } from './header/collection-info-header.component';
